import type { ApplicationState } from '../../types/tracked-job';
import { pipelineColumnKeyForState } from './group-applied-jobs-by-pipeline-column';
import type { BoardColumnKey } from './pipeline-stage-meta';

/**
 * A job's kanban stage for the SRP "stage chip" (search results know your pipeline —
 * SEEKER_HUB_PLAN.md P3 item 1). Reuses the exact same taxonomy as the My Jobs board
 * (pipelineColumnKeyForState/BoardColumnKey) so the chip and the board never disagree —
 * search and dashboard are two lenses on one dataset. Returns null when the job has no
 * relationship to the seeker yet (not saved, not applied).
 */
export function resolvePipelineStageChip(params: {
  isSaved: boolean;
  isApplied: boolean;
  applicationState: ApplicationState | null;
}): BoardColumnKey | null {
  if (params.isApplied) {
    return pipelineColumnKeyForState(params.applicationState);
  }
  if (params.isSaved) {
    return 'saved';
  }
  return null;
}
